/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_Upload_SuccessInputs */

const en_document_upload_success = /** @type {(inputs: Document_Upload_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document uploaded successfully`)
};

const id_document_upload_success = /** @type {(inputs: Document_Upload_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumen berhasil diunggah`)
};

/** @type {(inputs: Document_Upload_SuccessInputs) => LocalizedString} */
const es_document_upload_success = en_document_upload_success;

/** @type {(inputs: Document_Upload_SuccessInputs) => LocalizedString} */
const fr_document_upload_success = en_document_upload_success;

/** @type {(inputs: Document_Upload_SuccessInputs) => LocalizedString} */
const de_document_upload_success = en_document_upload_success;

/** @type {(inputs: Document_Upload_SuccessInputs) => LocalizedString} */
const ja_document_upload_success = en_document_upload_success;

/** @type {(inputs: Document_Upload_SuccessInputs) => LocalizedString} */
const zh_document_upload_success = en_document_upload_success;

/** @type {(inputs: Document_Upload_SuccessInputs) => LocalizedString} */
const ar_document_upload_success = en_document_upload_success;

/** @type {(inputs: Document_Upload_SuccessInputs) => LocalizedString} */
const it_document_upload_success = en_document_upload_success;

/** @type {(inputs: Document_Upload_SuccessInputs) => LocalizedString} */
const ru_document_upload_success = en_document_upload_success;

/** @type {(inputs: Document_Upload_SuccessInputs) => LocalizedString} */
const pt_document_upload_success = en_document_upload_success;

/** @type {(inputs: Document_Upload_SuccessInputs) => LocalizedString} */
const ko_document_upload_success = en_document_upload_success;

/**
* | output |
* | --- |
* | "Document uploaded successfully" |
*
* @param {Document_Upload_SuccessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const document_upload_success = /** @type {((inputs?: Document_Upload_SuccessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_Upload_SuccessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_document_upload_success(inputs)
	if (locale === "es") return es_document_upload_success(inputs)
	if (locale === "fr") return fr_document_upload_success(inputs)
	if (locale === "de") return de_document_upload_success(inputs)
	if (locale === "ja") return ja_document_upload_success(inputs)
	if (locale === "zh") return zh_document_upload_success(inputs)
	if (locale === "ar") return ar_document_upload_success(inputs)
	if (locale === "id") return id_document_upload_success(inputs)
	if (locale === "it") return it_document_upload_success(inputs)
	if (locale === "ru") return ru_document_upload_success(inputs)
	if (locale === "pt") return pt_document_upload_success(inputs)
	return ko_document_upload_success(inputs)
});